import axios from "axios";
import Config from "src/config";
import { authHeaders } from 'src/actions/authHeaders';

const v2_actionAgenteAi = (id) => {
    return axios({
        headers: authHeaders(),
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/agentes/${id}/detalhes`
        });
};

export default v2_actionAgenteAi;
